import {Base} from "@/api/Base"

export class CurrencyListAll extends Base {
    path = "currency/listAll"
}